module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_19.454ef897.jpg";